
<template>
  <section class="services-section ptb-100 gray-light-bg">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="section-heading text-center mb-5">
            <h2>{{ t('services.title') }}</h2>
          </div>
        </div>
      </div>

      <div class="row">
        <div
          v-for="service in services"
          :key="service.key"
          class="col-lg-4 col-md-6 col-sm-6"
        >
          <div class="services-single animated-hover text-center p-5 my-md-3 my-lg-3 my-sm-0 shadow-sm white-bg rounded">
            <img
              :src="`/assets/${service.image}`"
              :alt="t(`services.${service.key}.title`)"
              class="mb-3"
              width="80"
            />
            <h5>{{ t(`services.${service.key}.title`) }}</h5>
            <p class="mb-0">{{ t(`services.${service.key}.description`) }}</p>
            <a href="#" target="_blank" class="detail-link mt-4">
              {{ t(`services.${service.key}.more`) }} <span class="ti-arrow-right"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const services = [
  {
    key: 'consulting',
    image: 'consult.svg'
  },
  {
    key: 'ai_valuation',
    image: 'machine-learning.svg'
  },
  {
    key: 'market_analytics',
    image: 'data-analytics.svg'
  },
  {
    key: 'data_security',
    image: 'data-security.svg'
  },
  {
    key: 'automation',
    image: 'artificial-intelligence.svg'
  },
  {
    key: 'internet_solutions',
    image: 'internet-things.svg'
  }
]
</script>
